import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CollaboratorHelperService {

  private readonly collaboratorsRegex = new RegExp(`^${environment.collaboratorBasePath}`);

  constructor(private readonly router: Router) {
  }

  /**
   * Read from the router state rather than from a value cached on NavigationEnd: component constructors run while the
   * route is being activated, before NavigationEnd fires, so a cached value would still describe the previous page —
   * and on a direct page load it would describe no page at all.
   */
  public get isCollaboratorView(): boolean {
    const url = this.router.getCurrentNavigation()?.finalUrl?.toString() ?? this.router.url;
    return this.collaboratorsRegex.test(url);
  }
}
